var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_AGGREGATED_HOLDING, UPDATE_FOLIO_DETAILS, UPDATE_HOLDING_QTY_DETAILS, UPDATE_HOLDING_SUMMARY, UPDATE_RECENT_CLIENT_SEARCH_SAVE, UPDATE_SELECTED_LEAD_ID, UPDATE_TOGGLE, UPDATE_TRX_TYPE_LIST, UPDATE_TRX_TYPE_LIST_ITEM, UPDATE_UCCCLIENT_SEARCH, UPDATE_UCCCODECLIENT_SEARCH, UPDATE_VALIDATE_CLIENT, } from "../actions/GlobalAction";
var initialState = {
    trxTypeList: null,
    activeTypeList: {
        trx_type_code: 1,
        trx_type: "Purchase",
    },
    recentClientSave: null,
    validateClient: null,
    holdingSummary: null,
    folioDetails: null,
    holdingQtyDetails: null,
    aggregatedHolding: null,
    uccClientSearch: null,
    uccCodeClientSearch: null,
    toggleLeadSelection: false,
    selectLeadId: null,
};
var globalReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_TRX_TYPE_LIST:
            return __assign(__assign({}, state), { trxTypeList: action.payload.trxTypeList });
        case UPDATE_TOGGLE:
            return __assign(__assign({}, state), { toggleLeadSelection: action.payload.toggleLeadSelection });
        case UPDATE_SELECTED_LEAD_ID:
            return __assign(__assign({}, state), { selectLeadId: action.payload.selectLeadId });
        case UPDATE_RECENT_CLIENT_SEARCH_SAVE:
            return __assign(__assign({}, state), { recentClientSave: action.payload.recentClientSave });
        case UPDATE_TRX_TYPE_LIST_ITEM:
            return __assign(__assign({}, state), { activeTypeList: action.payload.activeTypeList });
        case UPDATE_VALIDATE_CLIENT:
            return __assign(__assign({}, state), { validateClient: action.payload.validateClient });
        case UPDATE_HOLDING_SUMMARY:
            return __assign(__assign({}, state), { holdingSummary: action.payload.holdingSummary });
        case UPDATE_FOLIO_DETAILS:
            return __assign(__assign({}, state), { folioDetails: action.payload.folioDetails });
        case UPDATE_HOLDING_QTY_DETAILS:
            return __assign(__assign({}, state), { holdingQtyDetails: action.payload.holdingQtyDetails });
        case UPDATE_AGGREGATED_HOLDING:
            return __assign(__assign({}, state), { aggregatedHolding: action.payload.aggregatedHolding });
        case UPDATE_UCCCLIENT_SEARCH:
            return __assign(__assign({}, state), { uccClientSearch: action.payload.uccClientSearch });
        case UPDATE_UCCCODECLIENT_SEARCH:
            return __assign(__assign({}, state), { uccCodeClientSearch: action.payload.uccCodeClientSearch });
        default:
            return state;
    }
};
export default globalReducer;
